import { types as t } from 'mobx-state-tree';

export const AbstractQuestion = t.model('AbstractQuestion', {
  uuid: t.identifier,
  type: t.string,
  marked: t.optional(t.array(t.string), []),
  scroll: t.optional(t.boolean, true),
});
